import React, { useEffect, useState } from "react";

import { Link, useNavigate } from "react-router-dom";
import "../styles/Quiz.css";

const Quiz = ({ isLoggedIn, setLoggedIn, doRefreshPosts, appRefresh }) => {
  // state variable for userToken, intiially set to an empty string
  const [showPartOne, setShowPartOne] = useState(true);  
 

  const [showPartTwo, setShowPartTwo] = useState(false); 
  const [userToken, setUserToken] = useState("");
  const [FilterCat, setFilterCat] = useState([]);

  const navigate = useNavigate();




  const handleCheckboxChange = (event, category) => {
    const value = event.target.value;
    setFilterCat((prevFilters) => {
      if (event.target.checked) {
        
        return [...prevFilters, value];
      } else {
        
        return prevFilters.filter((filter) => filter !== value);
      }
    });
  };

  const submitHandler = (event) => {
    event.preventDefault();

    const userId = sessionStorage.getItem("user");
    const userToken = sessionStorage.getItem("token");
    if (!userId || !userToken) {
      console.error("User ID or token is missing.");
      return;
    }

    fetch(`${process.env.REACT_APP_API_PATH}/users/${userId}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
      body: JSON.stringify({
        attributes: {
          filter: FilterCat,
        },
      }),
    })
      .then((response) => response.json())  
      .then((result) => {
        if (result) {
          sessionStorage.setItem("quizCompleted", "true");
          navigate("/");
          
          window.location.reload(); 
        }
      })
      .catch((error) => {
        console.error("Error in submitting quiz:", error);  // Handle error
      });
  };

  const handleNextClick = () => {
    setShowPartOne(false); // Hide part-one
    setShowPartTwo(true);  // Show part-two
  };

 
  const handleBackClick = () => {
    setShowPartOne(true); // Show part-one
    setShowPartTwo(false); // Hide part-two
  };


  
  useEffect(() => {
    const userId = sessionStorage.getItem("user");
    const userToken = sessionStorage.getItem("token");
    const hasTakenQuiz = sessionStorage.getItem("quizCompleted");

    if (!userId || !userToken) {
      navigate("/signup");
    } else if (hasTakenQuiz) {

      navigate("/settings");

    } else {
      setUserToken(userToken);
    }
   
  }, [navigate]);



  return (
    <div className="quizspace">
    <head>
      <link rel="preconnect" href="https://fonts.googleapis.com"></link>
      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin></link>
      <link
        href="https://fonts.googleapis.com/css2?family=Fredericka+the+Great&family=Fredoka:wght@500&family=Urbanist:ital,wght@0,500;1,500&display=swap"
        rel="stylesheet"
      ></link>
    </head>

    <div>
    {showPartOne && (
      <div className="part-one" id="part-one">
      <div class="align">Food Restrictions</div>
      <hr className="line"></hr>
      <div class="sub-align"><u>Food Allergy/Intolerance:</u></div>
      
      <div className="filter-option-container">
        <label className="filter-option">
          <input type="checkbox" value="Nut Free" onChange={handleCheckboxChange}/>
          <span className="check">Nut Free</span>
        </label>
      </div>
      <div className="filter-option-container">
        <label className="filter-option">
          <input type="checkbox" value="Shellfish Free" onChange={handleCheckboxChange} />
          <span className="check">Shellfish Free</span>
        </label>
      </div>
      <div className="filter-option-container">
        <label className="filter-option">
          <input type="checkbox" value="Seafood Free" onChange={handleCheckboxChange} />
          <span className="check">Seafood Free</span>
        </label>
      </div>
      <div className="filter-option-container">
        <label className="filter-option">
          <input type="checkbox" value="Wheat Free" onChange={handleCheckboxChange} />
          <span className="check">Wheat Free</span>
        </label>
      </div>
      <div className="filter-option-container">
        <label className="filter-option">
          <input type="checkbox" value="Soy Free" onChange={handleCheckboxChange} />
          <span className="check">Soy Free</span>
        </label>
      </div>
      <div className="filter-option-container">
        <label className="filter-option">
          <input type="checkbox" value="Dairy Free" onChange={handleCheckboxChange} />
          <span className="check">Dairy Free</span>
        </label>
      </div>
      <div className="filter-option-container">
        <label className="filter-option">
          <input type="checkbox" value="Gluten Free" onChange={handleCheckboxChange}/>
          <span className="check">Gluten Free</span>
        </label>
      </div>
      <div className="filter-option-container">
        <label className="filter-option">
          <input type="checkbox" value="Lactose Free" onChange={handleCheckboxChange} />
          <span className="check">Lactose Free</span>
        </label>
      </div>
      <br></br>
      <br></br>
      <div className="sub-align"><u>Diet Restrictions:</u></div>
      
      <div className="filter-option-container">
        <label className="filter-option">
          <input type="checkbox" value="Vegan" onChange={handleCheckboxChange} />
          <span className="check">Vegan</span>
        </label>
      </div>
      <div className="filter-option-container">
        <label className="filter-option">
          <input type="checkbox" value="Vegetarian" onChange={handleCheckboxChange}/>
          <span className="check">Vegetarian</span>
        </label>
      </div>
      <div className="filter-option-container">
        <label className="filter-option">
          <input type="checkbox" value="Pescatarian" onChange={handleCheckboxChange}/>
          <span className="check" >Pescatarian</span>
        </label>
      </div>
      <div className="filter-option-container">
        <label className="filter-option">
          <input type="checkbox" value="Halal" onChange={handleCheckboxChange} />
          <span className="check">Halal</span>
        </label>
      </div>
      <div className="filter-option-container">
        <label className="filter-option">
          <input type="checkbox" value="Kosher" onChange={handleCheckboxChange} />
          <span className="check">Kosher</span>
        </label>
      </div>

    
      <div className="align">Spice Tolerance</div>
      <hr className="line"></hr>
      <div className="filter-option-container">
        <label className="filter-option">
          <input type="checkbox" value="No Spice" onChange={handleCheckboxChange} />
          <span className="check">No Spice</span>
        </label>
      </div>
      <div className="filter-option-container">
        <label className="filter-option">
          <input type="checkbox" value="Mild" onChange={handleCheckboxChange}/>
          <span className="check">Mild</span>
        </label>
      </div>
      <div className="filter-option-container">
        <label className="filter-option">
          <input type="checkbox" value="Medium" onChange={handleCheckboxChange}/>
          <span className="check">Medium</span>
        </label>
      </div>
      <div className="filter-option-container">
        <label className="filter-option">
          <input type="checkbox" value="Hot" onChange={handleCheckboxChange}/>
          <span className="check">Hot</span>
        </label>
      </div>
      <div className="filter-option-container">
        <label className="filter-option">
          <input type="checkbox" value="Extreme" onChange={handleCheckboxChange} />
          <span className="check">Extreme</span>
        </label>
      </div>
      
      </div>
      )}

{showPartTwo && (
    <div className="part-two" id="part-two">
      <div className="align">Favorite Restaurants</div>
      <hr className="line"></hr>
      <div className="filter-option-container">
        <label className="filter-option">
          <input type="checkbox" value="Bravo Pasta at Pistachios" onChange={handleCheckboxChange} />
          <span className="check">Bravo Pasta at Pistachio's</span>
        </label>
      </div>
      <div className="filter-option-container">
        <label className="filter-option">
          <input type="checkbox" value="Breadbox at Pistachio's" onChange={handleCheckboxChange} />
          <span className="check">Breadbox at Pistachio's</span>
        </label>
      </div>
      <div className="filter-option-container">
        <label className="filter-option">
          <input type="checkbox" value="Cornor Cafe" onChange={handleCheckboxChange} />
          <span className="check">Cornor Cafe</span>
        </label>
      </div>
      <div className="filter-option-container">
        <label className="filter-option">
          <input type="checkbox" value="Crossroads Culinary Center" onChange={handleCheckboxChange} />
          <span className="check">Crossroads Culinary Center</span>
        </label>
      </div>
      <div className="filter-option-container">
        <label className="filter-option">
          <input type="checkbox" value="Harriman Café" onChange={handleCheckboxChange} />
          <span className="check">Harriman Café</span>
        </label>
      </div>
      <div className="filter-option-container">
        <label className="filter-option">
          <input type="checkbox" value="Hubies" onChange={handleCheckboxChange} />
          <span className="check">Hubies</span>
        </label>
      </div>
      <div className="filter-option-container">
        <label className="filter-option">
          <input type="checkbox" value="Noodle Pavilion" onChange={handleCheckboxChange} />
          <span className="check">Noodle Pavilion</span>
        </label>
      </div>
      <div className="filter-option-container">
        <label className="filter-option">
          <input type="checkbox" value="One World Express" onChange={handleCheckboxChange} />
          <span className="check">One World Express</span>
        </label>
      </div>
      <div className="filter-option-container">
        <label className="filter-option">
          <input type="checkbox" value="Pizza at Union Market" onChange={handleCheckboxChange} />
          <span className="check">Pizza at Union Market</span>
        </label>
      </div>
      <div className="filter-option-container">
        <label className="filter-option">
          <input type="checkbox" value="Whispers Café at Silverman" onChange={handleCheckboxChange} />
          <span className="check">Whispers Café at Silverman</span>
        </label>
      </div>

    

      <div className="align">Cuisine Preference</div>
      <hr className="line"></hr>
      <div className="filter-option-container">
        <label className="filter-option">
          <input type="checkbox" value="Mexican" onChange={handleCheckboxChange} />
          <span className="check">Mexican</span>
        </label>
      </div>
      <div className="filter-option-container">
        <label className="filter-option">
          <input type="checkbox" value="Chinese" onChange={handleCheckboxChange} />
          <span className="check">Chinese</span>
        </label>
      </div>
      <div className="filter-option-container">
        <label className="filter-option">
          <input type="checkbox" value="Japanese" onChange={handleCheckboxChange} />
          <span className="check">Japanese</span>
        </label>
      </div>
      <div className="filter-option-container">
        <label className="filter-option">
          <input type="checkbox" value="Korean" onChange={handleCheckboxChange} />
          <span className="check">Korean</span>
        </label>
      </div>
      <div className="filter-option-container">
        <label className="filter-option">
          <input type="checkbox" value="Indian" onChange={handleCheckboxChange} />
          <span className="check">Indian</span>
        </label>
      </div>
      <div className="filter-option-container">
        <label className="filter-option">
          <input type="checkbox" value="American" onChange={handleCheckboxChange} />
          <span className="check">American</span>
        </label>
      </div>
      <div className="filter-option-container">
        <label className="filter-option">
          <input type="checkbox" value="Italian" onChange={handleCheckboxChange} />
          <span className="check">Italian</span>
        </label>
      </div>
      
      <form onSubmit={submitHandler}>
  <button type="submit" class="submisson">Submit</button>
  </form>
      </div>
 )}
 <br></br>
  <button className="next" id="next" onClick={handleNextClick} style={{ display: showPartOne ? "block" : "none" }}>Next →</button>

  <button className="back" id="back" onClick={handleBackClick} style={{ display: showPartTwo ? "block" : "none" }}>← Back</button>
  
  
    </div>
    </div>
  );
};

export default Quiz;